<template>
    <div class="content-wrapper">

      <div id="map" class="sidebarx-map">
        <div id="popup" class="ol-popup">
          <a href="#" id="popup-closer" class="ol-popup-closer" @click="selectedFeature=null"></a>
          <div id="popup-content">
            <template v-if="selectedFeature">
              <table>
                <tr>
                  <td>Progresiva</td>
                  <td v-if="selectedFeature.get('tipo') === 'erosion'">
                    PK{{selectedFeature.get('progresiva_inicial_texto')}} - PK{{selectedFeature.get('progresiva_final_texto')}}
                  </td>
                  <td v-else>
                    PK{{selectedFeature.get('progresiva_texto')}}
                  </td>
                </tr>
                <tr>
                  <td>Probabilidad de Ocurrencia</td>
                  <td><span :class="'po-'+(selectedFeature.get('po')*10)">{{texto_param(selectedFeature.get('po'),'po')}}</span></td>
                </tr>
                <tr>
                  <td>Consecuencia</td>
                  <td><span :class="'consecuencia-'+selectedFeature.get('consecuencia')">
                    {{texto_param(selectedFeature.get('consecuencia'),'consecuencia')}}
                  </span></td>
                </tr>
                <tr>
                  <td>Riesgo</td>
                  <td><span :class="'riesgo-'+selectedFeature.get('riesgo')">{{texto_param(selectedFeature.get('riesgo'),'riesgo')}}</span></td>
                </tr>
              </table>
            </template>
          </div>
        </div>
        <div id="sidebarx" class="sidebarx collapsed">
          <!-- Nav tabs -->
          <div class="sidebarx-tabs">
              <ul role="tablist">
                  <li><a href="#capas" role="tab"><i class="fa fa-bars"></i></a></li>
                  <li><a href="#fecha" role="tab"><i class="fas fa-calendar-week"></i></a></li>
                  <li><a href="#segmentos" role="tab"><i class="fas fa-chart-line"></i></a></li>
                  <li><a href="#reporte" role="tab" target="_blank"><i class="fas fa-download"></i></a></li>
              </ul>
              <ul role="tablist">
                  <li><a href="#settings" role="tab"><i class="fa fa-gear"></i></a></li>
              </ul>
          </div>
          <!-- Tab panes -->
          <div class="sidebarx-content">
              <div class="sidebarx-pane" id="capas">
                  <h1 class="sidebarx-header">
                      sidebarx-v2
                      <span class="sidebarx-close"><i class="fa fa-caret-left"></i></span>
                  </h1>
                  <p>text</p>
              </div>
              <div class="sidebarx-pane" id="fecha">
                <h1 class="sidebarx-header">Semana<span class="sidebarx-close"><i class="fa fa-caret-left"></i></span></h1>
                <p>
                  <b-form-radio-group id="btnProyecto"
                                      style = "width:100%; padding-right:10px;"
                                      buttons
                                      v-model="param"
                                      :options="[{text:'Riesgo',value:'riesgo'},{text:'Consecuencia',value:'consecuencia'},{text:'Probabilidad',value:'po'}]"
                                      button-variant="outline-primary"
                                      name="radioBtnProyecto"
                                      value-field="value"
                                      text-field="text" />
                  <datepicker :inline="true" v-model="fecha"></datepicker>
                  <b-form-group label="Análisis de la semana">
                  <b-form-radio-group id="btnProyecto"
                                      style = "width:100%; padding-right:10px;"
                                      buttons
                                      stacked
                                      v-model="proyecto"
                                      :options="proyectos"
                                      button-variant="outline-primary"
                                      name="radioBtnProyecto"
                                      value-field="id"
                                      text-field="traza__nombre" />
                  </b-form-group>
                </p>
              </div>
              <div class="sidebarx-pane" id="segmentos">
                <h1 class="sidebarx-header">Reporte por segmentos<span class="sidebarx-close"><i class="fa fa-caret-left"></i></span></h1>
                <div class="tree" style="font-size:12px"><ul>
                  <li v-for="segmento in reporte" v-bind:key="segmento.id">
                    <span :class="param+'-'+(param==='po'?segmento['ipo']:segmento[param])" v-on:click="segmento.show=!segmento.show">
                      <fa-icon :icon="segmento.show?'minus':'plus'"/> {{texto_param(segmento[param])}}
                    </span>&nbsp;
                    <button type="button" @click="zoom_segmento(segmento)" class="btn btn-sm btn-info">
                    <i class="fa fa-eye"></i></button> PK{{segmento.progresiva_inicial_texto}} - PK{{segmento.progresiva_final_texto}}
                    <transition name="fade">
                      <ul v-if="segmento.show">
                        <li v-for="feature in segmento.features" v-bind:key="feature.id">
                          <span :class="param+'-'+(param==='po'?feature.get('ipo'):feature.get(param))" @click="seleccionar(feature)">{{texto_tipo(feature)}}</span>
                          <template v-if="feature.get('tipo')=='erosion'">
                            PK{{feature.get('progresiva_inicial_texto')}} - PK{{feature.get('progresiva_final_texto')}}
                          </template>
                          <template v-else>
                            PK{{feature.get('progresiva_texto')}}
                          </template>
                        </li>
                      </ul>
                    </transition>
                  </li>
                </ul></div>
              </div>
              <div class="sidebarx-pane" id="reporte">
                <h1 class="sidebarx-header">Messages<span class="sidebarx-close"><i class="fa fa-caret-left"></i></span></h1>
              </div>
              <div class="sidebarx-pane" id="settings">
                  <h1 class="sidebarx-header">Settings<span class="sidebarx-close"><i class="fa fa-caret-left"></i></span></h1>
              </div>
          </div>
        </div>

      </div>

    </div>
    <!-- /.content-wrapper -->
</template>

<script>
import Datepicker from 'vuejs-datepicker'

import 'ol/ol.css'
import { Map, View } from 'ol'
import GeoJSON from 'ol/format/GeoJSON'
import { XYZ, Vector as VectorSource } from 'ol/source'
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer'
import { Fill, RegularShape, Stroke, Style, Text, Circle } from 'ol/style'
import { defaults as defaultControls, FullScreen } from 'ol/control'
import { extend, createEmpty } from 'ol/extent'
import Overlay from 'ol/Overlay'
import Select from 'ol/interaction/Select'

import pluviometrosJson from '../assets/geojson/pluviometros.json'
import estratoJson from '../assets/geojson/estrato.json'
// import cashiriariJson from '../assets/geojson/cashiriari.json'
// import mipayaPagoreniJson from '../assets/geojson/mipaya_pagoreni.json'
// import mipayaJson from '../assets/geojson/mipaya.json'
// import pagoreniJson from '../assets/geojson/pagoreni.json'
// import sanMartinMalvinasJson from '../assets/geojson/san_martin_malvinas.json'
// import sanMartinJson from '../assets/geojson/san_martin.json'
// import u200 from '../assets/geojson/u200.json'
// import u600 from '../assets/geojson/u600.json'

import '../assets/css/ol3-sidebar.css'
import Sidebarx from '../assets/js/ol5-sidebar.js'

export default {
  name: 'Mapa',
  components: { Datepicker },
  data () {
    return {
      mapa: null,
      overlay: null,
      fecha: null,
      proyectos: [],
      proyecto: null,
      vector: new VectorLayer(),
      param: 'riesgo',
      reporte: null,
      select: null,
      selectedFeature: null
    }
  },
  mounted: function () {
    var obj = this

    this.overlay = new Overlay({
      element: document.getElementById('popup'),
      autoPan: true,
      autoPanAnimation: {
        duration: 250
      }
    })

    obj.mapa = new Map({
      target: 'map',
      layers: [
        new TileLayer({
          source: new XYZ({
            attributions: 'Tiles &copy; Esri',
            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
          })
        })
      ],
      overlays: [this.overlay],
      view: new View({
        projection: 'EPSG:4326',
        center: [ -72.93, -11.7 ],
        zoom: 10,
        maxZoom: 17
      }),
      controls: defaultControls().extend([
        new FullScreen()
      ])
    })

    /* this.mapa.on('singleclick', function(evt) {
      console.log(evt)
      var coordinate = evt.coordinate;
      var hdms = coordinate.toString();

      document.getElementById('popup-content').innerHTML = '<p>You clicked here:</p><code>' + hdms +
          '</code>';
      obj.overlay.setPosition(coordinate);
    }) */

    // var trazas = [
    //   { json: cashiriariJson, color: 'rgba(144,114,181,1.0)' },
    //   { json: mipayaPagoreniJson, color: 'rgba(231,145,5,1.0)' },
    //   { json: mipayaJson, color: 'rgba(231,145,5,1.0)' },
    //   { json: pagoreniJson, color: 'rgba(47,190,251,1.0)' },
    //   { json: sanMartinMalvinasJson, color: 'rgba(255,96,17,1.0)' },
    //   { json: sanMartinJson, color: 'rgba(255,96,17,1.0)' },
    //   { json: u200, color: 'rgba(15,231,69,1.0)' },
    //   { json: u600, color: 'rgba(34,80,231,1.0)' }
    // ]
    // for (var i = 0; i < trazas.length; i++) {
    //   obj.mapa.addLayer(new VectorLayer({
    //     source: new VectorSource({ features: (new GeoJSON()).readFeatures(trazas[i].json) }),
    //     style: this.style('rgba(200,200,200,1.0)')
    //   }))
    // }

    obj.loadTrazas()
    obj.mapa.addLayer(
      new VectorLayer({
        source: new VectorSource({
          features: (new GeoJSON()).readFeatures(pluviometrosJson)
        }),
        style: function (feature) {
          return new Style({
            image: new RegularShape({
              radius: 8.8,
              points: 4,
              stroke: new Stroke({ color: 'rgba(7,88,0,1.0)', lineDash: null, lineCap: 'butt', lineJoin: 'miter', width: 5 }),
              fill: new Fill({ color: 'rgba(84,176,74,1.0)' })
            }),
            text: new Text({
              font: '13.0px \'MS Shell Dlg 2\', sans-serif',
              text: String(feature.get('nombre')),
              textBaseline: 'middle',
              textAlign: 'left',
              offsetX: 8,
              offsetY: 3,
              placement: 'point',
              maxAngle: 0,
              stroke: new Stroke({ color: 'rgba(255,255,255,0.7)', lineDash: null, lineCap: 'butt', lineJoin: 'miter', width: 5 }),
              fill: new Fill({
                color: 'rgba(0, 0, 0, 1)'
              })
            })
          })
        },
        zIndex: 999
      })
    )
    obj.mapa.addLayer(
      new VectorLayer({
        source: new VectorSource({
          features: (new GeoJSON()).readFeatures(estratoJson)
        }),
        style: function (feature, resolution) {
          var style = [ new Style({
            stroke: new Stroke({
              color: 'rgba(35,35,35,0.0)',
              lineDash: null,
              lineCap: 'butt',
              lineJoin: 'miter',
              width: 0
            }),
            fill: new Fill({ color: 'rgba(251,154,153,0.5)' })
          })]

          return style
        },
        zIndex: 999
      })
    )
    var sidebar = new Sidebarx({ element: 'sidebarx', position: 'left' })
    obj.mapa.addControl(sidebar)

    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowHeight)
      this.getWindowHeight()
    })
  },
  methods: {
    style (color) {
      var textStyle = new Text({
        font: '10px, sans-serif',
        text: String(''),
        textBaseline: 'middle',
        textAlign: 'left',
        offsetX: 8,
        offsetY: 3,
        placement: 'line',
        maxAngle: 0,
        fill: new Fill({
          color: 'rgba(0, 0, 0, 1)'
        })
      })
      var style = [ new Style({
        stroke: new Stroke({ color: 'rgba(0,0,0,1.0)', lineDash: null, lineCap: 'round', lineJoin: 'round', width: 7 }),
        text: textStyle
      }), new Style({
        stroke: new Stroke({ color: color, lineDash: null, lineCap: 'round', lineJoin: 'round', width: 6 }),
        text: textStyle
      })]
      return style
    },
    texto_tipo (feature) {
      switch (feature.get('tipo')) {
        case 'erosion': return 'Erosión'
        case 'socavacion': return 'Socavación'
        case 'remocion': return 'Remoción'
        default: return ''
      }
    },
    texto_param (numero, param = null) {
      if (param === null) {
        param = this.param
      }
      switch (param) {
        case 'po': {
          var ipo = parseFloat(numero) * 10
          switch (ipo) {
            case 0: return 'bajo'
            case 2: return '20%'
            case 4: return '40%'
            case 6: return '60%'
            case 8: return '80%'
            case 10: return '100%'
            default: return ' - '
          }
        }
        case 'consecuencia': {
          switch (numero - 1) {
            case 0: return 'Muy Bajo'
            case 1: return 'Bajo'
            case 2: return 'Medio'
            case 3: return 'Alto'
            case 4: return 'Muy Alto'
            default: return ' - '
          }
        }
        case 'riesgo': {
          switch (numero) {
            case 0: return 'Muy Bajo'
            case 1: return 'Bajo'
            case 2: return 'Medio'
            case 3: return 'Alto'
            case 4: return 'Muy Alto'
            default: return ' - '
          }
        }
        default:
          return ' -- '
      }
    },
    color_riesgo (riesgo) {
      switch (riesgo) {
        case 0: return 'rgb(0,128,0)'
        case 1: return 'rgb(0,255,0)'
        case 2: return 'rgb(255,255,0)'
        case 3: return 'rgb(255,128,0)'
        case 4: return 'rgb(255,0,0)'
        default: return 'rgb(255,255,255)'
      }
    },
    color_consecuencia (consecuencia) {
      switch (consecuencia - 1) {
        case 0: return 'rgb(0,128,0)'
        case 1: return 'rgb(0,255,0)'
        case 2: return 'rgb(255,255,0)'
        case 3: return 'rgb(255,128,0)'
        case 4: return 'rgb(255,0,0)'
        default: return 'rgb(0,0,0)'
      }
    },
    color_po (po) {
      var ipo = parseFloat(po) * 10
      switch (ipo) {
        case 0: return 'rgb(255,255,255)'
        case 2: return 'rgb(0,128,0)'
        case 4: return 'rgb(0,255,0)'
        case 6: return 'rgb(255,255,0)'
        case 8: return 'rgb(255,128,0)'
        case 10: return 'rgb(255,0,0)'
        default: return 'rgb(0,0,0)'
      }
    },
    style_proyecto (select) {
      var obj = this
      var outlineColor = select ? 'white' : 'black'
      return function (feature, resolution) {
        var color = obj['color_' + obj.param](feature.get(obj.param))

        var style = null
        if (feature.get('tipo') === 'erosion') {
          style = [ new Style({
            stroke: new Stroke({ color: outlineColor, lineDash: null, lineCap: 'round', lineJoin: 'round', width: 10 })
          }), new Style({
            stroke: new Stroke({ color: color, lineDash: null, lineCap: 'round', lineJoin: 'round', width: 9 })
          })]
        } else {
          style = new Style({
            image: new Circle({
              radius: 7,
              fill: new Fill({ color: color }),
              stroke: new Stroke({ color: outlineColor, width: 2 })
            })
          })
        }
        return style
      }
    },
    zoom_segmento (segmento) {
      var extentx = createEmpty()
      for (var i = 0; i < segmento.features.length; i++) {
        extentx = extend(extentx, segmento.features[i].getGeometry().getExtent())
      }
      this.mapa.getView().fit(extentx)
    },
    seleccionar (feature) {
      this.select.getFeatures().clear()
      this.select.getFeatures().push(feature)
      this.selectedFeature = feature
    },
    onSelect (e) {
      var obj = this
      if (e.target.getFeatures().getLength()) {
        obj.selectedFeature = e.target.getFeatures().item(0)
      } else {
        obj.selectedFeature = null
      }
    },
    loadTrazas () {
      var obj = this
      var style = [ new Style({
        stroke: new Stroke({ color: 'rgba(0,0,0,1.0)', lineDash: null, lineCap: 'round', lineJoin: 'round', width: 7 })
      }), new Style({
        stroke: new Stroke({ color: 'rgba(200,200,200,1.0)', lineDash: null, lineCap: 'round', lineJoin: 'round', width: 6 })
      })]
      this.$http.get(this.$store.state.apiurl + '/trazas/1',
        this.urlconfig).then(function (resp) {
        var features = []
        var gjs = new GeoJSON()
        for (var i = 0; i < resp.data.length; i++) {
          features.push(gjs.readFeature(resp.data[i]))
        }
        var v = new VectorLayer({
          source: new VectorSource({ features: features }),
          style: style
        })
        obj.mapa.addLayer(v)
      })
    },
    loadProyecto () {
      var obj = this
      if (obj.proyecto) {
        this.$http.get(this.$store.state.apiurl + '/proyecto_reporte/500/' + obj.proyecto,
          this.urlconfig).then(function (resp) {
          var features = []
          var gjs = new GeoJSON()
          for (var i = 0; i < resp.data.length; i++) {
            resp.data[i].show = false
            for (var j = 0; j < resp.data[i].features.length; j++) {
              resp.data[i].features[j] = gjs.readFeature(resp.data[i].features[j])
              features.push(resp.data[i].features[j])
            }
          }
          if (obj.vector) {
            obj.mapa.removeLayer(obj.vector)
            obj.mapa.removeInteraction(obj.select)
          }
          obj.vector = new VectorLayer({
            source: new VectorSource({ features: features }),
            style: this.style_proyecto(false)
          })
          obj.mapa.addLayer(obj.vector)

          obj.select = new Select({
            style: obj.style_proyecto(true),
            layers: [obj.vector]
          })
          obj.mapa.addInteraction(this.select)
          obj.select.on('select', obj.onSelect)

          this.reporte = resp.data
        })
      }
    },
    getWindowHeight (event) {
      document.getElementById('map').style.height = (document.documentElement.clientHeight - document.getElementsByClassName('main-header')[0].clientHeight - 1) + 'px'
      this.mapa.updateSize()
    }
  },
  watch: {
    param: function (val, ant) {
      this.loadProyecto()
    },
    fecha: function (val, ant) {
      if (val) {
        this.$http.get(this.$store.state.apiurl + '/proyectos_semana/' + this.fecha.getFullYear() + '/' + (this.fecha.getMonth() + 1) + '/' + this.fecha.getDate(),
          this.urlconfig).then(function (resp) {
          this.proyectos = resp.data
        })
      }
    },
    proyecto: function (val, ant) {
      this.loadProyecto()
    },
    selectedFeature: function (val, ant) {
      var obj = this
      if (val) {
        var extent = val.getGeometry().getExtent()
        obj.overlay.setPosition([(extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2])
      } else {
        obj.select.getFeatures().clear()
        obj.overlay.setPosition(undefined)
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getWindowHeight)
  }
}
</script>

<style>
/*TREE*/
.tree ul {
    padding-left: 20px;
}
.tree {
    min-height:20px;
    padding:0px;
    margin-left: -10px;
}
.tree li {
    list-style-type:none;
    margin:0;
    padding:5px 5px 0 5px;
    position:relative
}
.tree li:not(.no-tree)::before, .tree li:not(.no-tree)::after {
    content:'';
    left:-5px;
    position:absolute;
    right:auto
}
.tree li::before {
    border-left:1px solid #999;
    bottom:50px;
    height:100%;
    top:0;
    width:1px
}
.tree li::after {
    border-top:1px solid #999;
    height:20px;
    top:15px;
    width:10px
}
.tree li span,  .ol-popup span {
    -moz-border-radius:5px;
    -webkit-border-radius:5px;
    border:1px solid #999;
    border-radius:5px;
    display:inline-block;
    padding:3px 8px;
    text-decoration:none;
    font-weight: bold;
}
.tree li.parent_li>span, .riesgo-4:not(.no-hover), .riesgo-3:not(.no-hover), .riesgo-2:not(.no-hover), .riesgo-1:not(.no-hover), .riesgo-0:not(.no-hover),
.consecuencia-4:not(.no-hover), .consecuencia-3:not(.no-hover), .consecuencia-2:not(.no-hover), .consecuencia-1:not(.no-hover), .consecuencia-0:not(.no-hover),
.po-10:not(.no-hover), .po-8:not(.no-hover), .po-6:not(.no-hover), .po-4:not(.no-hover), .po-2:not(.no-hover), .po-0:not(.no-hover) {
    cursor:pointer
}
.tree>ul>li::before, .tree>ul>li::after {
    border:0
}
.tree li:last-child::before {
    height:30px
}
.tree li.parent_li>span:hover, .tree li.parent_li>span:hover+ul li span {
    /*background:#eee;*/
    /*border:1px solid #94a0b4;*/
    /*color:#000*/
}

.po-0{
  color: #000;
  background: rgb(255,255,255);
}
.po-0:not(.no-hover):hover, li.parent_li>span:hover+ul li span.po-0 {
    background-color: rgb(240,240,240);
}

.riesgo-4, .po-10, .consecuencia-5{
    color: #fff;
    background-color: rgb(255,0,0);
}
.riesgo-4:not(.no-hover):hover, li.parent_li>span:hover+ul li span.riesgo-4,
.po-10:not(.no-hover):hover, li.parent_li>span:hover+ul li span.po-10,
.consecuencia-5:not(.no-hover):hover, li.parent_li>span:hover+ul li span.consecuencia-5{
    background-color: rgb(200,0,0);
}
.riesgo-3, .consecuencia-4, .po-8 {
    color: #fff;
    background-color: rgb(255,128,0);
}
.riesgo-3:not(.no-hover):hover, li.parent_li>span:hover+ul li span.riesgo-3,
.consecuencia-4:not(.no-hover):hover, li.parent_li>span:hover+ul li span.consecuencia-4,
.po-8:not(.no-hover):hover, li.parent_li>span:hover+ul li span.po-8{
    background-color: rgb(200,100,0);
}
.riesgo-2, .consecuencia-3, .po-6 {
    color: #444;
    background-color: rgb(255,255,0);
}
.riesgo-2:not(.no-hover):hover, li.parent_li>span:hover+ul li span.riesgo-2,
.consecuencia-3:not(.no-hover):hover, li.parent_li>span:hover+ul li span.consecuencia-3,
.po-6:not(.no-hover):hover, li.parent_li>span:hover+ul li span.po-6{
    background-color: rgb(200,200,0);
}
.riesgo-1, .consecuencia-2, .po-4 {
    color: #444;
    background-color: rgb(0,255,0);
}
.riesgo-1:not(.no-hover):hover, li.parent_li>span:hover+ul li span.riesgo-1,
.consecuencia-2:not(.no-hover):hover, li.parent_li>span:hover+ul li span.consecuencia-2,
.po-4:not(.no-hover):hover, li.parent_li>span:hover+ul li span.po-4{
    background-color: rgb(0,200,0);
}
.riesgo-0, .consecuencia-1,.po-2 {
    color: #fff;
    background-color: rgb(0,128,0);
}
.riesgo-0:not(.no-hover):hover, li.parent_li>span:hover+ul li span.riesgo-0,
.consecuencia-1:not(.no-hover):hover, li.parent_li>span:hover+ul li span.consecuencia-1,
.po-2:not(.no-hover):hover, li.parent_li>span:hover+ul li span.po-2{
    background-color: rgb(0,100,0);
}
/************************************/

.ol-popup {
  position: absolute;
  background-color: white;
  -webkit-filter: drop-shadow(0 1px 4px rgba(0,0,0,0.2));
  filter: drop-shadow(0 1px 4px rgba(0,0,0,0.2));
  padding: 15px;
  border-radius: 10px;
  border: 1px solid #cccccc;
  bottom: 12px;
  left: -50px;
  min-width: 280px;
}
.ol-popup:after, .ol-popup:before {
  top: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.ol-popup:after {
  border-top-color: white;
  border-width: 10px;
  left: 48px;
  margin-left: -10px;
}
.ol-popup:before {
  border-top-color: #cccccc;
  border-width: 11px;
  left: 48px;
  margin-left: -11px;
}
.ol-popup-closer {
  text-decoration: none;
  position: absolute;
  top: 2px;
  right: 8px;
}
.ol-popup-closer:after {
  content: "✖";
}

.tree .btn-sm {
    padding: .1rem .3rem;
    line-height: 1;
}
</style>
